import { useEffect, useState } from 'react';
import { checkIsUserLogin, isAdmin, isOperatore, isSystem, IsMedico } from '../utils';
import { PATH } from '../helpers/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RancareIcon from '../img/output.png';
import OTSUKA from '../img/Logo_Otsuka.png';
import QUICARE from '../img/Logo_Quicare.png';
import LES from '../img/logoLES.png';
import ANMAR from '../img/logoANMAR.png';
import { faUserTie, faUsersLine, faUserDoctor, faHospital, faCommentDots, faSitemap, faSignOut, faLineChart } from '@fortawesome/free-solid-svg-icons';
const SideNav = () => {
    const [url] = useState(window.location.pathname);
    useEffect(() => {
        checkIsUserLogin()
    }, [url]);

    return (
        <>
            {checkIsUserLogin() ?
                <header className="col b-r-navbar">
                    <a href={PATH.SPLASH} className="logo"><img src={RancareIcon} alt="Logo" height={100} /></a>
                    <button className="menu-toggle d-block d-lg-none ">
                        <span />
                        <span />
                        <span />
                    </button>
                    <ul className="nav flex-column main-menu">
                        <li className="nav-item ">
                            <a href={PATH.PROFILO} className="nav-link profilo-paziente-nome" aria-current="page" >
                                <p className="custom-mobile-text">
                                    <FontAwesomeIcon icon={faUserTie} />
                                    <p className="hidden-on-small">
                                        {JSON.parse(localStorage.getItem("nominativo")).toString()}
                                    </p>
                                </p>
                                <p className="hidden-on-small">
                                    {isAdmin() ? "Amministratore" : isOperatore() ? "Operatore" : IsMedico() ? "Medico" : ""}
                                </p>
                            </a>
                        </li>
                        <hr />
                        {isOperatore() || isAdmin() || isSystem() ?
                            <>
                                <li className="nav-item">
                                    <a href={PATH.DASCHBOARD} className="nav-link" aria-current="page" >
                                        <p className="custom-mobile-text">
                                            <FontAwesomeIcon icon={faLineChart} />
                                        </p>
                                        <p className="hidden-on-small"> Dashboard</p>
                                    </a>
                                </li>
                            </> : <></>}
                        <li className="nav-item">
                            <a href={PATH.LISTAPAZIENTI} className="nav-link elenco-pazienti" aria-current="page" >
                                <p className="custom-mobile-text">
                                    <FontAwesomeIcon icon={faUsersLine} />
                                </p>
                                <p className="hidden-on-small"> Elenco Pazienti</p>
                            </a>
                        </li>

                        {isOperatore() || isAdmin() || isSystem() ?
                            <>
                                <li className="nav-item">
                                    <a href={PATH.LISTAMEDICI} className="nav-link nuovo-paziente" aria-current="page" >
                                        <p className="custom-mobile-text">
                                            <FontAwesomeIcon icon={faUserDoctor} />
                                        </p>
                                        <p className="hidden-on-small">  Elenco Medici</p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href={PATH.LISTACENTRIMEDICI} className="nav-link nuovo-centroMedico" aria-current="page" >
                                        <p className="custom-mobile-text">
                                            <FontAwesomeIcon icon={faHospital} />
                                        </p>
                                        <p className="hidden-on-small"> Elenco Centri Medici</p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href={PATH.LISTAMODELLI} className="nav-link no-kit" aria-current="page" >
                                        <p className="custom-mobile-text">
                                            <FontAwesomeIcon icon={faCommentDots} />
                                        </p>
                                        <p className="hidden-on-small">  Lista Modelli Questionario</p>
                                    </a>
                                </li> 
                                <li className="nav-item">
                                    <a href={PATH.LISTAWEBINAR} className="nav-link elenco-pazienti" aria-current="page" >
                                        <p className="custom-mobile-text">
                                            <FontAwesomeIcon icon={faUsersLine} />
                                        </p>
                                        <p className="hidden-on-small">  Elenco Webinar</p>
                                    </a>
                                </li>
                                </> : <></>}
                        {isAdmin() ?
                            <>
                                <li className="nav-item">
                                    <a href={PATH.LISTAOPERATORI} className="nav-link profilo-paziente" aria-current="page" >
                                        <p className="custom-mobile-text">
                                            <FontAwesomeIcon icon={faSitemap} />
                                        </p>
                                        <p className="hidden-on-small"> Lista Operatori</p>
                                    </a>
                                </li>
                            </> : <></>}
                        <li className="nav-item">
                            <a href="/" className="nav-link logout" >
                                <p className="custom-mobile-text">
                                    <FontAwesomeIcon icon={faSignOut} />
                                </p>
                                <p className="hidden-on-small">  Logout</p>
                            </a>
                        </li>
                    </ul>
                    <p className="hidden-on-small  ml-8">
                        Progetto a cura di: <br />
                        <img src={QUICARE} alt="QuiCare" height={35} />
                    </p>
                    <br />
                    <p className="hidden-on-small  ml-8">
                        Realizzato con il contributo di: <br />
                        <img src={OTSUKA} alt="OTSUKA" height={35} />
                    </p>
                    <br />

                    <p className="hidden-on-small  ml-8">
                        Con il patrocinio di: <br />
                        <img src={ANMAR} alt="OTSUKA" height={35} />
                        <br />
                        <img src={LES} alt="OTSUKA" height={35} />

                    </p>


                </header>
                : <></>
            }
        </>
    )
}

export default SideNav
